import { render, staticRenderFns } from "./PlusSurNous.vue?vue&type=template&id=4c89fff8&scoped=true&"
import script from "./PlusSurNous.vue?vue&type=script&lang=js&"
export * from "./PlusSurNous.vue?vue&type=script&lang=js&"
import style0 from "./PlusSurNous.vue?vue&type=style&index=0&id=4c89fff8&prod&lang=scss&"
import style1 from "./PlusSurNous.vue?vue&type=style&index=1&id=4c89fff8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c89fff8",
  null
  
)

export default component.exports